import React from 'react'
import {Button, Dialog} from '@startlibs/components'
import {WithForm,Errors} from '@startlibs/form'
import {formFetch, postFetcher} from '@startlibs/utils'
import {useNotificationRef} from '../../../components/Notifications'
import {StudyCard} from '../StudyCard'

export const ManageReportDialog = ({closeDialog,refreshList,url,study}) => {
  const [,setNotification] = useNotificationRef()

  const status = study.tools.report.reportStatus
  const canMarkAsRead = status == "Draft" || status == "Pending"

  return <WithForm
    skipDom
    // action={() =>  fetch("/StudyResetReportOwner.php",{
    //   method: "POST",
    //   headers: {"Content-Type": "application/x-www-form-urlencoded"},
    //   body: "study_pk=" + study.study.id
    // })}
    action={formFetch("/StudyResetReportOwner.php")}
    values={{
      id: study.study.id,
      patientID: study?.patient?.patientID,
      patientName: study?.patient?.patientName,
      studyUID: study?.study?.iuid,
      studyDescription: study?.study?.studyDescription,
      dictatedBy : study?.study?.dictated_by
    }}
    // values={{
    //   study_pk: Number(study.study.id)
    // }}
    alwaysSave
    onSuccess={() => refreshList().then(closeDialog).then(() => setNotification("Study report successfully unlocked"))}
  >{form =>
    <Dialog
      closeDialog={closeDialog}
      // title="Mark as read confirmation"
      title={"Unlock editing permissions"}
      footer={<>
        <Button onClick={closeDialog}>Cancel</Button>
        <Button highlight onClick={form.willSubmitForm} type="submit" isLoading={form.isLoading}>
          {"Yes, unlock it"}
        </Button>
      </>}
    >
      <StudyCard study={study}/>
      <>
        <p><b>Would you like to unlock the editing permission of the following study?</b></p>
        <p>Editing permission will remain open until a new user begins editing this report.</p>
        <p>No previously entered information will be lost.</p>
      </>
      <Errors/>
    </Dialog>
  }</WithForm>

}
